import { formatToYYYYMonDD } from "../../utils/customC2CFormat";
import { fCapitalizeFirst } from "../../utils/formatString";
import { NumberTypeChecker } from "../../utils/formatTime";
import { TIMESHEET_STATUS } from "../../utils/timesheetUtils";
import React from "react";
import {
  Box,
  Tooltip,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody
} from "@mui/material";
import Iconify from "../../components/Iconify";

export const TimeSheetList_Table_Header = [
  {
    id: "employee_full_name",
    label: "Name",
    align: "left",
    format: (dataItem) =>
      dataItem?.employee_full_name ? (
        <span
          style={{
            cursor: "pointer",
            color: "#2196F3",
            textDecoration: "underline"
          }}
        >
          {fCapitalizeFirst(dataItem?.employee_full_name)}
        </span>
      ) : (
        "--"
      )
  },
  {
    id: "resource_role",
    label: "Role",
    align: "left",
    format: (dataItem) =>
      dataItem?.resource_role ? dataItem.resource_role : "--"
  },
  {
    id: "ongoing_projects",
    label: "Active Projects",
    align: "center",
    format: (dataItem) =>
      dataItem?.ongoing_projects !== undefined
        ? NumberTypeChecker(dataItem?.ongoing_projects)
        : "--"
  },
  {
    id: "completed_projects",
    label: "Completed Projects",
    align: "center",
    format: (dataItem) =>
      dataItem?.completed_projects !== undefined
        ? NumberTypeChecker(dataItem?.completed_projects)
        : "--"
  }
];

export const Consultants_list = [
  {
    id: "employee_id",
    label: "Employee Id",
    align: "left",
    format: (dataItem) => (dataItem?.employee_id ? dataItem.employee_id : "--")
  },
  {
    id: "employee_full_name",
    label: "Name",
    align: "left",
    format: (dataItem) =>
      dataItem?.employee_full_name ? (
        <span
          style={{
            cursor: "pointer",
            color: "#2196F3",
            textDecoration: "underline"
          }}
        >
          {fCapitalizeFirst(dataItem?.employee_full_name)}
        </span>
      ) : (
        "--"
      )
  },

  {
    id: "projects",
    label: "Projects",
    align: "left",
    format: (dataItem) => {
      return (
        <React.Fragment>
          <Tooltip
            arrow
            placement="top"
            slotProps={{
              popper: {
                sx: {
                  "& .MuiTooltip-tooltip": {
                    backgroundColor: "#fff",
                    color: "#222",
                    padding: 2,
                    minWidth: 320,
                    borderRadius: 4,
                    boxShadow: "0 2px 8px rgba(0,0,0,0.10)",
                    fontSize: 14
                  }
                }
              }
            }}
            title={
              <Box>
                <Box sx={{ fontWeight: "bold", mb: 1, color: "#222" }}>
                  Active clients and projects:
                </Box>
                {Array.isArray(dataItem?.data?.clients) &&
                dataItem.data.clients.length > 0 ? (
                  <TableContainer>
                    <Table size="small" sx={{ minWidth: 260 }}>
                      <TableHead>
                        <TableRow>
                          <TableCell
                            sx={{
                              fontWeight: "bold",
                              color: "#222",
                              borderBottom: "1px solid #eee"
                            }}
                          >
                            No.
                          </TableCell>
                          <TableCell
                            sx={{
                              fontWeight: "bold",
                              color: "#222",
                              borderBottom: "1px solid #eee"
                            }}
                          >
                            Client
                          </TableCell>
                          <TableCell
                            sx={{
                              fontWeight: "bold",
                              color: "#222",
                              borderBottom: "1px solid #eee"
                            }}
                          >
                            Projects
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {dataItem.data.clients.map((client, idx) => (
                          <TableRow key={client.client_id}>
                            <TableCell
                              sx={{
                                color: "#222",
                                borderBottom: "none",
                                width: 32
                              }}
                            >
                              {idx + 1}.
                            </TableCell>
                            <TableCell
                              sx={{ color: "#222", borderBottom: "none" }}
                            >
                              {client.client_name}
                            </TableCell>
                            <TableCell
                              sx={{ color: "#222", borderBottom: "none" }}
                            >
                              {client.projects && client.projects.length > 0 ? (
                                client.projects
                                  .map((project) => project.project_name)
                                  .join(", ")
                              ) : (
                                <span
                                  style={{ color: "#888", fontStyle: "italic" }}
                                >
                                  No projects
                                </span>
                              )}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                ) : (
                  <Box sx={{ color: "#888", fontStyle: "italic" }}>
                    No projects found
                  </Box>
                )}
              </Box>
            }
          >
            <span
              style={{
                cursor: "pointer",
                display: "inline-flex",
                alignItems: "center"
              }}
            >
              <Iconify
                icon="eva:eye-outline"
                sx={{ color: "#2196F3", fontSize: 22 }}
              />
            </span>
          </Tooltip>
        </React.Fragment>
      );
    }
  },
  {
    id: "employee_email",
    label: "Email",
    align: "left",
    format: (dataItem) =>
      dataItem?.employee_email ? dataItem.employee_email : "--"
  },
  {
    id: "employee_department",
    label: "Department",
    align: "left",
    format: (dataItem) =>
      dataItem?.employee_department ? dataItem.employee_department : "--"
  }
];
export const TimeSheetWeekWiseStatusList_Table_Header = [
  {
    id: "start_date",
    label: "Start Date",
    align: "left",
    format: (dataItem) => formatToYYYYMonDD(dataItem?.start_date)
  },
  {
    id: "end_date",
    label: "End Date",
    align: "left",
    format: (dataItem) => formatToYYYYMonDD(dataItem?.end_date)
  },
  {
    id: "allocated_hours",
    label: "Allocated Hours",
    align: "center",
    format: (dataItem) =>
      dataItem?.allocated_hours !== undefined ? dataItem.allocated_hours : "0"
  },
  {
    id: "billable_hours",
    label: "Timesheet Hours",
    align: "center",
    format: (dataItem) =>
      dataItem?.timesheet_hours !== undefined ? dataItem.timesheet_hours : "0ed"
  },

  {
    id: "approved_by",
    label: "Approved By",
    align: "center",
    format: (dataItem) =>
      dataItem?.timesheet_status === TIMESHEET_STATUS.approved &&
      dataItem?.approved_by
        ? dataItem.approved_by
        : "--"
  },

  {
    id: "approved_on",
    label: "Approved On",
    align: "center",
    format: (dataItem) =>
      dataItem?.timesheet_status === TIMESHEET_STATUS.approved &&
      dataItem?.approved_on
        ? formatToYYYYMonDD(dataItem.approved_on)
        : "--"
  },
  {
    id: "submitted",
    label: "Status",
    align: "center"
  }
];
export const MissingTimesheets_Table_Header = [
  {
    id: "start_date",
    label: "Start Date",
    align: "left",
    format: (dataItem) => formatToYYYYMonDD(dataItem?.week_start_date)
  },
  {
    id: "end_date",
    label: "End Date",
    align: "left",
    format: (dataItem) => formatToYYYYMonDD(dataItem?.week_end_date)
  },
  {
    id: "submitted",
    label: "Status",
    align: "center"
  }
];
export const TimeSheetUnplannedHrsList_Table_Header = [
  {
    id: "start_date",
    label: "Start Date",
    align: "left",
    format: (dataItem) => formatToYYYYMonDD(dataItem?.start_date)
  },
  {
    id: "end_date",
    label: "End Date",
    align: "left",
    format: (dataItem) => formatToYYYYMonDD(dataItem?.end_date)
  },
  {
    id: "unplanned_hours",
    label: "Unplanned Hours",
    align: "center",
    format: (dataItem) =>
      dataItem?.unplanned_hours !== undefined ? dataItem.unplanned_hours : "0"
  },
  {
    id: "unplanned_hours_comments",
    label: "Comments",
    align: "center",
    format: (dataItem) =>
      dataItem?.unplanned_hours_comments !== undefined
        ? dataItem.unplanned_hours_comments
        : "--"
  }
];

export const TimeSheetTimeOffHrsList_Table_Header = [
  {
    id: "start_date",
    label: "Start Date",
    align: "left",

    format: (dataItem) => formatToYYYYMonDD(dataItem?.start_date)
  },
  {
    id: "end_date",
    label: "End Date",
    align: "left",

    format: (dataItem) => formatToYYYYMonDD(dataItem?.end_date)
  },
  {
    id: "non_billable_hours",
    label: "Time Off Hours",
    align: "center",
    format: (dataItem) =>
      dataItem?.non_billable_hours !== undefined
        ? dataItem.non_billable_hours
        : "0"
  },
  {
    id: "non_billable_hours_comments",
    label: "Comments",
    align: "center",
    format: (dataItem) =>
      dataItem?.non_billable_hours_comments !== undefined
        ? dataItem.non_billable_hours_comments
        : "--"
  }
];
